export const ERROR_MESSAGE = {
  INVALID_USER_TYPE: 'ProDoctorsの利用ドクター側のURLで再度お試しください。',
  INVALID_USER_TYPE_ADMIN:
    'ProDoctorsの医療機関側または利用ドクター側のURLで再度お試しください。',
  TOKEN_EXPIRED: '認証の有効期限が切れました。再ログインしてください。',
};
